export default {
  title: 'Yhteystiedot',
  form: {
    customer_first_name: {
      placeholder: 'Etunimi',
    },
    customer_last_name: {
      placeholder: 'Sukunimi',
    },
    customer_email: {
      placeholder: 'Sähköpostiosoite',
    },
    customer_phone_number: {
      placeholder: 'Puhelinnumero',
    },
  },
  validation: {
    customer_first_name: {
      required: 'Anna etunimesi',
    },
    customer_last_name: {
      required: 'Anna sukunimesi',
    },
    customer_email: {
      required: 'Anna sähköpostiosoitteesi',
    },
    customer_phone_number: {
      required: 'Anna puhelinnumerosi',
    },
  },
};
